import { Col, Container, Row } from "react-bootstrap"
import logo from '../assets/img/logo.png'
import navIcon1 from '../assets/img/nav-icon1.svg'
import navIcon2 from '../assets/img/nav-icon2.svg'
import navIcon3 from '../assets/img/nav-icon3.svg'

export const Footer = () => {
    return (
        <footer className="footer">
            <Container>
                <Row className="align-item-center">
                    <Col sm={6}>
                        <img src={logo} className="footer-logo"/>
                    </Col>
                    <Col sm={6} className="text-center text-sm-end footer-content">
                        <div className="social-icon">
                        <a href="https://www.linkedin.com/in/tang-zong-hao"><img src={navIcon1} alt=""/></a>
                        <a href="https://github.com/ZHTang29"><img src={navIcon2} alt=""/></a>
                        <a href="https://instagram.com/zonghaoo"><img src={navIcon3} alt=""/></a>
                        </div>
                        <p>Copyright 2024. All rights reserved.</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}   